module.exports = __webpack_public_path__ + "static/media/iconCommitRide.045ce5eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconCommitRide.svg
// module id = 941
// module chunks = 0